import { post} from '@/util/utils';
import axios from 'axios';

function queryMachineWorkDetail(machineNumber) {
	return post('dashboard/queryMachineWorkDetail', {
		machineNumber: machineNumber
	});
}

function getEuipment(){
    const payload = {
        "appKey": "31f3fd104bb77c10",
        "sign": "ZmNiMzBjOGVkNWZiZWI0ODRlYzc0NzkwMGIwZmZhNzMxN2RlOWU5YmNmMDc2MzRiMDI2ODIyNzAxMDA1ODc2Nw==",
        "worksheetId": 'equ_list',
        "viewId": "",
        "pageSize": 1000,
        "pageIndex": 1,
      };
    const headers = {
        'Content-Type': 'application/json'
    }
    var response_data=axios.post('/api/v2/open/worksheet/getFilterRows', payload,{headers})
    return response_data;
}

export {getEuipment, queryMachineWorkDetail};
